import { useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3D from 'highcharts/highcharts-3d';
import { Tabs, Tab } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useSelector } from 'react-redux';

// Only call if necessary (if 3D isn't already enabled in your version)
// Highcharts3D(Highcharts);

const DonutChart = () => {
    const { countryGraph } = useSelector(state => state.data);
    const { industryGraph } = useSelector(state => state.data);
    const [activeKey, setActiveKey] = useState('countries');

    const getChartData = () => {
        if (activeKey === 'countries') {
            const data = countryGraph.map(({ country, percentage }) => [country, percentage]);
            // console.log(data, "data")
            return data;
        } else {
            const data = industryGraph.map(({ industry, percentage }) => [industry, percentage]);
            // console.log(data, "data")
            return data;
        }
    };

    const chartOptions = {
        chart: {
            type: 'pie',
            options3d: {
                enabled: true,
                alpha: 45,
                beta: 0,
            },
            backgroundColor: '#fff',
        },
        title: {
            text: 'Count and Distribution',
            align: 'center',
        },
//         title: {
//     text: activeKey === 'countries'
//         ? 'Count and Distribution'
//         : 'Industries',
//     align: 'center',
// },
        credits: { enabled: false }, // 🔹 remove "highcharts.com"
        plotOptions: {
            pie: {
                innerSize: 100,
                depth: 45,
                dataLabels: {
                    enabled: true,
                    format: '{point.name}: {point.percentage:.1f} %',
                },
            },
        },
        series: [
            {
                name: activeKey === 'countries' ? 'Countries' : 'Industries',
                data: getChartData(),
            },
        ],
    };

    return (
        <div className='donut-chart-div'>
            <Tabs
                id="donut-chart-tabs"
                activeKey={activeKey}
                onSelect={(k) => setActiveKey(k)}
                className="mb-3"
            >
                <Tab eventKey="countries" title="Countries">
                    <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                </Tab>
                <Tab eventKey="industries" title="Industries">
                    <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                </Tab>
            </Tabs>
        </div>
    );
};

export default DonutChart;
